import React, { useEffect, useState } from 'react';

import classNames from 'classnames';

import { IconButton } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { ICON_NAMES, MaterialDesignIcon } from '../util/material-design-icons';

interface Props {
  canBeDismissed?: boolean;
  message?: any;
  variant?: 'error' | 'warning' | 'informational' | null;
  className?: string;
  onMessageDismissed?: () => void;
  /**
   * Cypress selector for identifying buttons in end-to-end testing
   * sets the data-cy attribute on the button element
   * @see https://docs.cypress.io/guides/references/best-practices#Selecting-Elements
   */
  dataCy?: string;
}

// Can be removed in PROD0-4039, all uses in code should be updated to UiMessageBanner
const Message = ({
  canBeDismissed = true,
  message,
  variant = null,
  className,
  onMessageDismissed,
  children,
  dataCy,
}: React.PropsWithChildren<Props>) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);

  // reopen dismissed message if message content changes
  useEffect(() => {
    setIsOpen(true);
  }, [message]);

  const paperStyle = classNames({
    'u-background-yellowMuted': variant === 'warning',
    'u-background-blueMuted': variant === 'informational',
    'u-background-redMuted': variant === 'error',
    'u-background-lightGrayMuted': !variant,
  });

  const handleCloseClick = () => {
    if (onMessageDismissed) {
      onMessageDismissed();
    }

    setIsOpen(false);
  };

  return isOpen ? (
    <Paper className={`${paperStyle} ${className || ''} u-padding`} data-cy={dataCy}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item xs={canBeDismissed ? 10 : 12}>
          {children}
          {!children ? <Typography variant="subtitle1">{message}</Typography> : null}
        </Grid>
        {canBeDismissed ? (
          <Grid item>
            <IconButton onClick={handleCloseClick}>
              <MaterialDesignIcon iconName={ICON_NAMES.CLOSE} />
            </IconButton>
          </Grid>
        ) : null}
      </Grid>
    </Paper>
  ) : null;
};

export default Message;
